import { render } from "./MlfsTable.vue?vue&type=template&id=4c152326"
import script from "./MlfsTable.vue?vue&type=script&lang=js"
export * from "./MlfsTable.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./MlfsTable.vue?vue&type=style&index=0&id=4c152326&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script